import firebase from "firebase/app";
import { giftCategoryCollection } from "@/firebase";
import { giftCollection } from "@/firebase";
import { v4 as uuidv4 } from "uuid";
import { storage } from "@/firebase";
import store from "@/store";
import * as c from "@/constants";

const state = {
  giftCategory: [],
};

const getters = {};

const actions = {
  getGiftCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.mode == "live") {
        giftCategoryCollection
          .where("client", "==", payload.client)
          .where("superCategory", "==", payload.superCategory)
          .where("active", "==", true)
          .orderBy("order", "asc")
          .orderBy("name", "asc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];

            querySnapshot.forEach((doc) => {
              const copy = doc.data();

              let arr = store.state.storePromoCode.activePromoCodes.filter(
                (x) => x.module == c.G_MODULE_PHOTO_GIFT && !x.hidden && x.superCategoryName == doc.data().superCategory
              );

              if (typeof copy.enableDeviceBasedEdit === 'undefined') {
                Object.assign(copy, { enableDeviceBasedEdit: false }); // dodamo podatek, če še ne obstaja v bazi              
              }

              if (arr.length > 0) {
                if ((arr[0].category.length > 0 && arr[0].categoryName == doc.data().name) || arr[0].category.length == 0) {
                  tempData.push(Object.assign(copy, { id: doc.id, discount: arr[0] }));
                } else
                  tempData.push(Object.assign(copy, { id: doc.id }));
              } else tempData.push(Object.assign(copy, { id: doc.id }));
            });

            /*querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });*/

            resolve(commit("getGiftCategory", tempData));
          })
          .catch(function (error) {
            reject(console.log("Error getting documents: ", error));
          });
      } else
        giftCategoryCollection
          .where("client", "==", payload.client)
          .orderBy("order", "asc")
          .orderBy("name", "asc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];
            querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });
            resolve(commit("getGiftCategory", tempData));
          })
          .catch(function (error) {
            reject(console.log("Error getting documents: ", error));
          });
    });
  },
  addGiftCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.order = Number(payload.order); // String => Number

      if (payload.image !== undefined) {
        let uploadPath = "giftCategory/" + payload.client + "-" + uuidv4();

        payload.imageURL = uploadPath;
        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(payload.image);

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.image = downloadURL;
                giftCategoryCollection
                  .add(payload)
                  .then((docRef) => {
                    console.log("Added record.");
                    resolve(
                      commit(
                        "addGiftCategory",
                        Object.assign(payload, { id: docRef.id })
                      )
                    );
                  })
                  .catch((error) => {
                    reject(console.log(error));
                  });
              });
          },
        });
      } else {
        payload.image = "";
        giftCategoryCollection
          .add(payload)
          .then((docRef) => {
            console.log("Added record.");
            resolve(
              commit(
                "addGiftCategory",
                Object.assign(payload, { id: docRef.id })
              )
            );
          })
          .catch((error) => {
            reject(console.log(error));
          });
      }
    });
  },
  removeGiftCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      giftCategoryCollection
        .doc(payload)
        .delete()
        .then(() => {
          resolve(commit("removeGiftCategory", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  editGiftCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.order = Number(payload.order); // String => Number

      if (payload.image == undefined) {
        payload.image = payload.image2;
        delete payload.image2;
        giftCategoryCollection
          .doc(payload.id)
          .set(payload, { merge: true })
          .then(() => {
            resolve(commit("editGiftCategory", payload));
          })
          .catch((error) => {
            reject(console.log(error));
          });
      } else {
        let uploadPath = "";
        if (payload.image2.length <= 0) {
          // edit, prejšnje stanje brez slike (add v storage)
          uploadPath = "giftCategory/" + payload.client + "-" + uuidv4();
          //console.log(uploadPath);
          payload.imageURL = uploadPath;
        } else {
          // edit, prejšnje stanje s sliko (replace v storage)
          uploadPath = payload.imageURL;
        }
        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(payload.image);

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.image = downloadURL;
                delete payload.image2;
                giftCategoryCollection
                  .doc(payload.id)
                  .set(payload, { merge: true })
                  .then(() => {
                    resolve(commit("editGiftCategory", payload));
                  })
                  .catch((error) => {
                    reject(console.log(error));
                  });
              });
          },
        });
      }
    });
  },
  // eslint-disable-next-line
  removeImageLinkFromGiftCategory({ commit }, payload) {
    console.log(payload);
    return new Promise((resolve, reject) => {
      payload.image = ""; payload.imageURL = "";
      giftCategoryCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGiftCategory", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  beforeDeleteRemoveGiftCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      giftCollection
        .where("client", "==", payload.client)
        .where("giftCategory", "==", payload.giftCategory)
        .limit(1)
        .get()
        .then((res) => {
          if (res.empty) {
            console.log("EMPTY");
            resolve(true);
          } else {
            console.log("FULL");
            resolve(false);
          }
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleGiftCategoryBooleanActive({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.active = !payload.active;
      giftCategoryCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGiftCategory", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
};

const mutations = {
  getGiftCategory(state, payload) {
    state.giftCategory = payload;
    //console.log(state.giftCategory);
  },
  addGiftCategory(state, payload) {
    state.giftCategory.push(payload);
  },
  removeGiftCategory(state, payload) {
    const index = state.giftCategory.findIndex((item) => item.id == payload);
    state.giftCategory.splice(index, 1);
  },
  editGiftCategory(state, payload) {
    const index = state.giftCategory.findIndex((item) => item.id == payload.id);
    state.giftCategory.splice(index, 1, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
